/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Change_Title_MemberInputs */



/**
* | output |
* | --- |
* | "Change seat type" |
*
* @param {Seat_Change_Title_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_title_member = /** @type {((inputs?: Seat_Change_Title_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Title_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Platztyp ändern")
	return /** @type {LocalizedString} */ ("Change seat type")
});